<template>
  <div class="partners">
    <template v-if="type == 'financial'">
      <financial />
    </template>
    <template v-if="type == 'farming'">
      <farming />
    </template>
    <template v-if="type == 'num'">
      <num />
    </template>
  </div>
</template>
<script>
import financial from './components/financial'
import farming from './components/farming'
import num from './components/num'
export default {
  components: { financial, farming, num },
  data() {
    return {
      type: '',
    }
  },
  mounted() {
    this.type = this.$route.params.type
  },

  methods: {},
}
</script>

<style lang="scss">
.partners {
  width: 7.5rem;
  min-height: 5rem;
  background: #131721;
}
</style>
